import React, { Component } from 'react';
import { Container, Form } from 'react-bootstrap';
import '../styles/MaintainAccess.css';
import { PrimaryUserAdminTable } from '../components/PrimaryUserAdminTable';
import { SupplierTable } from '../components/SupplierTable';
import { AdditionalUsersTable } from '../components/AdditionalUsersTable';
import '../styles/PopUps.css';
import ServiceCalls from '../utils/serviceCalls.js';
import { Loading } from '../components/Loading';

export default class SupplierAccess extends Component {

    constructor(props) {
        super(props);
        this.onUserAdded = this.onUserAdded.bind(this);
        this.supplierStatusUpdated = this.supplierStatusUpdated.bind(this);
        this.state = {
            userAdded: false,
            adminInfo: {},
            adminFetched: false,
            supplierStatusChange:false
        }
    }
    componentDidMount() {
        //Determine if current user can add user
          this.getAdminInfo(false);     
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentCompanyId !== prevProps.currentCompanyId) {
            this.getAdminInfo(false);            
        }
    }

    onUserAdded = () => {
        this.setState(
            {
                userAdded: true
            });
        this.setState(
            {
                userAdded: false
            });
    }

    supplierUpdated = () => {
        this.getAdminInfo(true);
    }
    supplierStatusUpdated = (isUpdating) => {
        if (!isUpdating) {
           
            this.getAdminInfo(true);
        }
        else {
            this.setState({
                supplierStatusChange: isUpdating  //Only when true
            });
        }
    }
    //Gets admin information with contactsController
    getAdminInfo(userAdded) {
       // console.log(`Getting SPUA for ${this.props.currentCompanyId}`);
        ServiceCalls.getSupplierAdmin(this.props.currentCompanyId).then(function (data) {
            if (data) {
                //console.log(`Returned new SPUA for Supplier ${this.props.currentCompanyId}`);
                if (userAdded===true) {
                    this.setState(
                        {
                            adminInfo: data,
                            userAdded: true,
                            adminFetched: true,
                            supplierStatusChange:false
                        });              
                    //Prevents child components from continuously updating
                    this.setState({ userAdded: false, adminFetched: false, supplierStatusChange: false });
                }
                else {
                    this.setState({ adminInfo: data, adminFetched: true, userAdded: false, supplierStatusChange: false });
                }
            }
            else {
                //update not successful. - need to handle
                //this.setState({ isLoading: false });
            }
        }.bind(this));
    }

  
    render() {
        const { currentUser, currentCompanyId } = this.props;
        const { adminInfo, userAdded, adminFetched, supplierStatusChange } = this.state;
        var spuaEmail = (adminInfo && adminFetched) ? adminInfo.email : '';
        var supplierUpddateDisplay = <></>;
        //If we want to show a loading icon.  May need to enclose in a Container.
//            <div style={{ margin: "auto", width: "200px" }}>
//            Updating Supplier <br /> <Loading />
 //       </div>;

        var SPUATable = (supplierStatusChange)
            ? supplierUpddateDisplay
            : <PrimaryUserAdminTable currentUser={currentUser} currentCompanyId={currentCompanyId} onUserUpdated={this.supplierUpdated} spuaInfo={adminInfo} isSupplierUpdated={supplierStatusChange} />;

        var additionalUsersTable = (supplierStatusChange)
            ? supplierUpddateDisplay
            : <AdditionalUsersTable currentUser={currentUser} currentCompanyId={currentCompanyId} userAdded={userAdded} onUserAdded={this.onUserAdded} onUsersUpdated={this.supplierUpdated} spuaEmail={spuaEmail} onAdminFetched={adminFetched} isSupplierUpdated={supplierStatusChange} />;

        return (
            <>
                <Container fluid as={Form}>
                    <SupplierTable currentUser={currentUser} currentCompanyId={currentCompanyId} onSupplierStatusUpdated={this.supplierStatusUpdated} />
                    {SPUATable}
                    {additionalUsersTable}
                </Container>               
            </>
        );
    }
}
